export default __webpack_public_path__ + "static/media/about.f95ecc11.png";